import {Component, Input} from '@angular/core';
import {FORM_ERROR_SCROLL_HOOK} from 'src/app/helpers/form.helper';

@Component({
    selector: 'app-form-control-errors',
    templateUrl: './form-control-errors.component.html',
    styleUrls: ['./form-control-errors.component.less'],
})
export class FormControlErrorsComponent {
    @Input() errors: string[] = [];
    FORM_ERROR_SCROLL_HOOK = FORM_ERROR_SCROLL_HOOK;

    get showErrors() {
        return Array.isArray(this.errors) && this.errors.length;
    }
}
